import React, { useEffect, useState } from "react";
import axios from "axios";
import { api_url } from "../config/config";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import banner from "../images/aboutimages/banners.png";
import about_s from "../images/aboutimages/abt_s.jpeg";

/* ─────────────────────────────────────────────
   ABOUT US — MediSYS Pharmacy
   ▸ Desktop hero  → autoplay MP4 video (360degreeabout.mp4)
   ▸ Mobile hero   → about_s.jpeg fallback image
   ▸ Founder section is COMMENTED OUT below —
     uncomment + fill details once available.
───────────────────────────────────────────── */

const statCards = [
  {
    value: "2022",
    label: "Founded",
    icon: (
      <>
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </>
    ),
  },
  {
    value: "Hyderabad",
    label: "Headquartered",
    icon: (
      <>
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
      </>
    ),
  },
  {
    value: "5+",
    label: "Store Locations",
    icon: (
      <>
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </>
    ),
  },
  {
    value: "  50K+",
    label: "Products",
    icon: (
      <>
        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
        <line x1="3" y1="6" x2="21" y2="6" />
        <path d="M16 10a4 4 0 0 1-8 0" />
      </>
    ),
  },
];

const sections = [
  {
    iconPath: (
      <>
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </>
    ),
    label: "Our Story",
    heading: "From Vision to a Pharma Mall",
    body: `What started as a vision to move beyond traditional medical stores has evolved into a modern "Pharma Mall" concept — a space where customers can explore, discover, and access everything they need for their health and well-being.\n\nFounded in 2022 and headquartered in Hyderabad, MediSYS Pharmacy is not just a pharmacy — it is a next-generation pharma retail destination designed to bring together healthcare, wellness, and lifestyle under one roof.\n\nFrom our flagship store in Panjagutta to multiple locations across Hyderabad, MediSYS continues to grow rapidly, serving customers with quality products, expert guidance, and a superior shopping experience.`,
    isOrange: false,
  },
  {
    iconPath: (
      <>
        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
        <line x1="3" y1="6" x2="21" y2="6" />
        <path d="M16 10a4 4 0 0 1-8 0" />
      </>
    ),
    label: "What We Offer",
    heading: "One-Stop Healthcare Destination",
    body: "We go beyond being a regular pharmacy. MediSYS is a one-stop destination for:",
    list: [
      "Prescription & OTC medicines",
      "Surgical & healthcare equipment",
      "Wellness and personal care products",
      "Branded cosmetics & skincare",
      "FMCG and everyday health essentials",
    ],
    note: "Our wide product range ensures customers find everything they need in one place — saving time while enhancing convenience.",
    isOrange: true,
  },
  {
    iconPath: (
      <>
        <rect x="2" y="3" width="20" height="14" rx="2" />
        <path d="M8 21h8M12 17v4" />
      </>
    ),
    label: "Pharma Mall Experience",
    heading: "Beyond the Traditional Pharmacy",
    body: "Unlike traditional pharmacies, MediSYS is designed as a walk-in, self-service retail experience:",
    list: [
      "Spacious, modern store layouts",
      "Easy product browsing & self-selection",
      "Organized categories for seamless shopping",
      "Premium ambiance for comfort and convenience",
    ],
    note: "We believe that healthcare shopping should be simple, transparent, and enjoyable.",
    isOrange: false,
  },
  {
    iconPath: (
      <>
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </>
    ),
    label: "Convenience at Your Doorstep",
    heading: "Your Health, Our Priority",
    body: "Your health is our priority, and convenience is our promise:",
    list: [
      "Free home delivery across nearby locations",
      "Easy ordering via phone or WhatsApp",
      "Flexible payment options (UPI, cards, cash)",
      "Extended store hours for accessibility",
    ],
    note: "We ensure essential medicines and products reach you when you need them most.",
    isOrange: true,
  },
];

const whyCards = [
  {
    icon: (
      <>
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
        <polyline points="22 4 12 14.01 9 11.01" />
      </>
    ),
    title: "Wide Range Under One Roof",
    desc: "Everything from medicines to cosmetics, wellness to FMCG — all in one store.",
  },
  {
    icon: (
      <>
        <line x1="12" y1="1" x2="12" y2="23" />
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
      </>
    ),
    title: "Competitive Pricing",
    desc: "Transparent and affordable pricing with no hidden charges.",
  },
  {
    icon: (
      <>
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </>
    ),
    title: "Authentic Products",
    desc: "100% genuine, quality-verified products from trusted manufacturers.",
  },
  {
    icon: (
      <>
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </>
    ),
    title: "Customer-First Approach",
    desc: "Expert staff, personalized guidance, and a shopping experience built around you.",
  },
  {
    icon: (
      <>
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </>
    ),
    title: "Extended Hours",
    desc: "Open longer so you can access medicines and health products when you need them.",
  },
  {
    icon: (
      <>
        <rect x="1" y="3" width="15" height="13" />
        <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
        <circle cx="5.5" cy="18.5" r="2.5" />
        <circle cx="18.5" cy="18.5" r="2.5" />
      </>
    ),
    title: "Free Home Delivery",
    desc: "Fast, reliable delivery straight to your doorstep across nearby locations.",
  },
];

const AboutUs = () => {
  const [storeCount, setStoreCount] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchBranches = async () => {
      try {
        const response = await axios.get(`${api_url}/branches`);
        const rawBranches = response.data.results || [];
        const uniqueBranches = [
          ...new Map(rawBranches.map((b) => [b.branch_id, b])).values(),
        ];
        setStoreCount(uniqueBranches.length);
      } catch (error) {
        console.error("Error fetching branches:", error);
      }
    };
    fetchBranches();
  }, []);

  return (
    <div className="min-h-screen bg-[#f8fafa]  mt-36 lg:mt-0 font-poppins overflow-x-hidden">
      <Helmet>
        <title>
          About Us | MediSYS Pharmacy – Redefining Healthcare Retail
        </title>
        <meta
          name="description"
          content="Learn about MediSYS Pharmacy — a next-generation pharma retail destination in Hyderabad delivering healthcare, wellness, and lifestyle under one roof."
        />
        <meta
          name="keywords"
          content="MediSYS Pharmacy, about us, online pharmacy Hyderabad, pharma mall, healthcare retail"
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="About Us | MediSYS Pharmacy" />
        <meta
          property="og:description"
          content="MediSYS Pharmacy — where healthcare meets convenience, innovation, and trust."
        />
      </Helmet>

      {/* ══════════════════════════════════════
          HERO — Desktop (MP4 video banner)
      ══════════════════════════════════════ */}
      <section className="relative h-[400px] lg:h-[500px] overflow-hidden">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source
            src={require("../../src/images/360degreeabout.mp4")}
            type="video/mp4"
          />
          {/* Fallback if video fails */}
          <img
            src={banner}
            alt="About MediSYS Banner"
            className="w-full h-full object-cover"
          />
        </video>

        {/* Gradient overlays */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a1715]/88 via-[#162c2a]/65 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a1715]/40 to-transparent" />

        {/* Content */}
        <div className="absolute inset-0 flex flex-col justify-center px-10 lg:px-24">
          {/* Breadcrumb */}
          {/* <nav className="flex items-center gap-2 text-[12px] text-[#5fbdb3]/70 mb-5 font-medium">
            <Link to="/home" className="hover:text-[#5fbdb3] transition-colors">
              Home
            </Link>
            <svg width="10" height="10" viewBox="0 0 16 16" fill="none">
              <path
                d="M6 12l4-4-4-4"
                stroke="#5fbdb3"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className="text-[#5fbdb3] font-bold">About Us</span>
          </nav> */}

          <div className="flex items-center gap-2 mb-3">
            <span className="w-7 h-[2px] bg-[#ff601e] rounded-full" />
            <span className="text-[11px] lg:text-[13px] font-bold uppercase tracking-widest text-[#accdca]">
              Est. 2022 · Hyderabad
            </span>
          </div>

          <h1
            className="font-black text-white text-[28px] lg:text-[50px] leading-tight max-w-[600px]"
            style={{ fontFamily: "'Nunito',sans-serif" }}
          >
            Redefining Pharmacy.
            <br />
            <span className="text-white">Reinventing</span> Healthcare Retail.
          </h1>

          <p className="mt-3 text-[14px] lg:text-[16px] text-white/85 font-medium max-w-[440px] leading-relaxed">
            Next-generation pharma retail — healthcare, wellness &amp; lifestyle
            under one roof.
          </p>

          {/* Stat pills */}
          <div className="flex flex-wrap gap-2.5 mt-6">
            {statCards.map((s) => (
              <div
                key={s.label}
                className="flex items-center gap-2 bg-[#0a1715]/60 border border-white/15 backdrop-blur-sm rounded-xl px-3.5 py-2"
              >
                <div className="w-6 h-6 rounded-lg bg-[#1e4a46] flex items-center justify-center flex-shrink-0">
                  <svg
                    width="11"
                    height="11"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#5fbdb3"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    {s.icon}
                  </svg>
                </div>
                <div>
                  <div
                    className="text-[13px] font-black text-white leading-none"
                    style={{ fontFamily: "'Nunito',sans-serif" }}
                  >
                    {/* Use live store count from API for Store Locations card */}
                    {s.label === "Store Locations"
                      ? storeCount !== null
                        ? `${storeCount}`
                        : s.value
                      : s.value}
                  </div>
                  <div className="text-[10px] text-[#5fbdb3]/80 font-medium leading-none mt-0.5">
                    {s.label}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* <Link to="/products" className="mt-7 inline-block">
            <button className="flex items-center gap-2 bg-[#ff601e] hover:bg-[#e55519] text-white font-bold text-[14px] lg:text-[15px] px-6 lg:px-8 h-[44px] lg:h-[50px] rounded-xl transition-all duration-200 shadow-[0_4px_18px_rgba(255,96,30,0.45)] hover:shadow-[0_6px_24px_rgba(255,96,30,0.6)] hover:-translate-y-0.5 border-none">
              Shop Now
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </button>
          </Link> */}
        </div>

        {/* Bottom fade into page bg */}
        <div className="absolute bottom-0 left-0 right-0 h-4 bg-gradient-to-t from-[#f8fafa] to-transparent" />
      </section>

      {/* ══════════════════════════════════════
          HERO — Mobile (about_s image)
      ══════════════════════════════════════ */}
      {/* <section className="block md:hidden relative h-[300px] sm:h-[340px] overflow-hidden mt-16">
        <img
          src={about_s}
          alt="About MediSYS"
          className="w-full h-full object-cover opacity-80"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a1715]/88 via-[#162c2a]/60 to-transparent" />
        <div className="absolute inset-0 flex flex-col justify-center px-5">
          <div className="flex items-center gap-2 mb-2">
            <span className="w-4 h-[2px] bg-[#ff601e] rounded-full" />
            <span className="text-[10px] font-bold uppercase tracking-widest text-[#5fbdb3]">
              Est. 2022 · Hyderabad
            </span>
          </div>
          <h1
            className="font-black text-white text-[22px] sm:text-[27px] leading-tight"
            style={{ fontFamily: "'Nunito',sans-serif" }}
          >
            Redefining Pharmacy.
            <br />
            <span className="text-[#5fbdb3]">Reinventing</span> Healthcare.
          </h1>
          <p className="mt-2 text-[12px] text-white/65 font-medium max-w-[300px]">
            Healthcare meets convenience, innovation, and trust.
          </p>
          <Link to="/products" className="mt-4 inline-block">
            <button className="flex items-center gap-2 bg-[#ff601e] hover:bg-[#e55519] text-white font-bold text-[13px] px-5 h-[40px] rounded-xl transition-all duration-200 shadow-[0_3px_12px_rgba(255,96,30,0.4)] border-none">
              Shop Now
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </button>
          </Link>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-10 bg-gradient-to-t from-[#f8fafa] to-transparent" />
      </section> */}

      {/* ══════════════════════════════════════
          PAGE BODY
      ══════════════════════════════════════ */}
      <div className="mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 flex flex-col gap-10">
        {/* ── Content Sections ── */}
        {sections.map((sec, i) => (
          <div
            key={i}
            className={`rounded-2xl border-[1.5px] overflow-hidden ${
              sec.isOrange
                ? "border-[#ffd5c2] bg-gradient-to-br from-[#fff3ee] to-white"
                : "border-[#d4ecea] bg-gradient-to-br from-[#eaf4f3] to-white"
            }`}
            style={{ animation: `fadeInUp 0.4s ease ${i * 60}ms both` }}
          >
            <div
              className={`h-[3px] ${sec.isOrange ? "bg-[#ff601e]" : "bg-[#5fbdb3]"}`}
            />
            <div className="p-6 sm:p-8">
              <div className="flex items-center gap-2 mb-2">
                <div
                  className={`w-7 h-7 rounded-lg flex items-center justify-center ${sec.isOrange ? "bg-[#fff3ee] border border-[#ffd5c2]" : "bg-[#eaf4f3] border border-[#d4ecea]"}`}
                >
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke={sec.isOrange ? "#ff601e" : "#5fbdb3"}
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    {sec.iconPath}
                  </svg>
                </div>
                <span
                  className={`text-[11px] font-bold uppercase tracking-widest ${sec.isOrange ? "text-[#ff601e]" : "text-[#5fbdb3]"}`}
                >
                  {sec.label}
                </span>
              </div>

              <h2
                className="text-[20px] sm:text-[24px] font-black text-[#1e4a46] mb-4"
                style={{ fontFamily: "'Nunito',sans-serif" }}
              >
                {sec.heading}
              </h2>

              {sec.body && (
                <p className="text-[14px] sm:text-[15px] text-[#374747] leading-relaxed whitespace-pre-line mb-4">
                  {sec.body}
                </p>
              )}

              {sec.list && (
                <ul className="flex flex-col gap-2.5 mb-4">
                  {sec.list.map((item, j) => (
                    <li key={j} className="flex items-start gap-2.5">
                      <div
                        className={`mt-0.5 w-5 h-5 rounded-md flex items-center justify-center flex-shrink-0 ${sec.isOrange ? "bg-[#ff601e]/10 border border-[#ff601e]/20" : "bg-[#5fbdb3]/15 border border-[#5fbdb3]/25"}`}
                      >
                        <svg
                          width="9"
                          height="9"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke={sec.isOrange ? "#ff601e" : "#5fbdb3"}
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="20 6 9 17 4 12" />
                        </svg>
                      </div>
                      <span className="text-[14px] text-[#374747] leading-snug">
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              )}

              {sec.note && (
                <p className="text-[13px] text-[#8faba9] italic border-l-2 pl-3 border-[#d4ecea]">
                  {sec.note}
                </p>
              )}
            </div>
          </div>
        ))}

        {/* ── Mission & Vision ── */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {[
            {
              label: "Our Mission",
              icon: (
                <>
                  <circle cx="12" cy="12" r="10" />
                  <polygon points="10 8 16 12 10 16 10 8" />
                </>
              ),
              text: "To deliver affordable, accessible, and high-quality healthcare products while creating a modern retail experience that customers trust and prefer.",
              isOrange: false,
            },
            {
              label: "Our Vision",
              icon: (
                <>
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                </>
              ),
              text: "To become India's leading pharma retail chain, redefining pharmacy stores into intelligent, customer-centric healthcare destinations.",
              isOrange: true,
            },
          ].map((mv) => (
            <div
              key={mv.label}
              className={`rounded-2xl border-[1.5px] overflow-hidden ${mv.isOrange ? "border-[#ffd5c2] bg-gradient-to-br from-[#fff3ee] to-white" : "border-[#d4ecea] bg-gradient-to-br from-[#eaf4f3] to-white"}`}
            >
              <div
                className={`h-[3px] ${mv.isOrange ? "bg-[#ff601e]" : "bg-[#5fbdb3]"}`}
              />
              <div className="p-6">
                <div className="flex items-center gap-2.5 mb-3">
                  <div
                    className={`w-9 h-9 rounded-xl flex items-center justify-center ${mv.isOrange ? "bg-[#ff601e]/10 border border-[#ff601e]/20" : "bg-[#5fbdb3]/15 border border-[#5fbdb3]/25"}`}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke={mv.isOrange ? "#ff601e" : "#5fbdb3"}
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      {mv.icon}
                    </svg>
                  </div>
                  <h3
                    className="text-[16px] font-black text-[#1e4a46]"
                    style={{ fontFamily: "'Nunito',sans-serif" }}
                  >
                    {mv.label}
                  </h3>
                </div>
                <p className="text-[14px] text-[#374747] leading-relaxed">
                  {mv.text}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* ── Why Choose MediSYS ── */}
        <div>
          <div className="flex items-center gap-2 mb-2">
            <span className="w-5 h-[2px] bg-[#ff601e] rounded-full" />
            <span className="text-[11px] font-bold uppercase tracking-widest text-[#ff601e]">
              Our Strengths
            </span>
          </div>
          <h2
            className="text-[22px] sm:text-[26px] font-black text-[#1e4a46] mb-6"
            style={{ fontFamily: "'Nunito',sans-serif" }}
          >
            Why Choose MediSYS Pharmacy?
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {whyCards.map((card, i) => {
              const isOrange = i % 2 === 1;
              return (
                <div
                  key={i}
                  className={`rounded-2xl border-[1.5px] p-5 flex flex-col gap-3 hover:-translate-y-1 transition-all duration-200 ${
                    isOrange
                      ? "border-[#ffd5c2] bg-gradient-to-br from-[#fff3ee] to-white hover:border-[#ff601e]/50"
                      : "border-[#d4ecea] bg-gradient-to-br from-[#eaf4f3] to-white hover:border-[#5fbdb3]"
                  }`}
                  style={{ animation: `fadeInUp 0.35s ease ${i * 40}ms both` }}
                >
                  <div
                    className={`w-10 h-10 rounded-xl flex items-center justify-center ${isOrange ? "bg-[#ff601e]/10 border border-[#ff601e]/20" : "bg-[#5fbdb3]/15 border border-[#5fbdb3]/25"}`}
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke={isOrange ? "#ff601e" : "#5fbdb3"}
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      {card.icon}
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-[13px] font-bold text-[#1e4a46] mb-1">
                      {card.title}
                    </h4>
                    <p className="text-[12px] text-[#8faba9] leading-relaxed">
                      {card.desc}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* ══════════════════════════════════════
            FOUNDER SECTION — COMMENTED OUT
            Uncomment when founder details are ready.
            Replace placeholder text with real info.
        ══════════════════════════════════════ */}
        {/*
        <div className="rounded-2xl border-[1.5px] border-[#d4ecea] bg-gradient-to-br from-[#eaf4f3] to-white overflow-hidden">
          <div className="h-[3px] bg-[#5fbdb3]" />
          <div className="p-6 sm:p-8">

            <div className="flex items-center gap-2 mb-2">
              <div className="w-7 h-7 rounded-lg bg-[#eaf4f3] border border-[#d4ecea] flex items-center justify-center">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#5fbdb3" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
              </div>
              <span className="text-[11px] font-bold uppercase tracking-widest text-[#5fbdb3]">Leadership</span>
            </div>

            <h2 className="text-[20px] sm:text-[24px] font-black text-[#1e4a46] mb-6" style={{ fontFamily: "'Nunito',sans-serif" }}>
              Meet Our Founders
            </h2>

            <div className="flex flex-col sm:flex-row flex-wrap gap-8 justify-center">

              // ── Founder 1 ──
              <div className="flex flex-col items-center sm:items-start sm:flex-row gap-5 max-w-[420px]">
                <div className="w-24 h-24 rounded-2xl bg-[#eaf4f3] border-[1.5px] border-[#d4ecea] overflow-hidden flex-shrink-0">
                  // Replace src with actual founder image import
                  // import founder1 from "../images/aboutimages/Mask group.png";
                  // <img src={founder1} alt="Founder Name" className="w-full h-full object-cover" />
                  <div className="w-full h-full flex items-center justify-center">
                    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#5fbdb3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                      <circle cx="12" cy="7" r="4"/>
                    </svg>
                  </div>
                </div>
                <div>
                  <span className="inline-block text-[10px] font-bold uppercase tracking-widest text-[#ff601e] bg-[#fff3ee] border border-[#ffd5c2] px-2 py-0.5 rounded-full mb-1.5">Founder</span>
                  <h3 className="text-[16px] font-black text-[#1e4a46] mb-0.5">[ Founder Name ]</h3>
                  <p className="text-[12px] text-[#5fbdb3] font-semibold mb-2">Founder & CEO, MediSYS Pharmacy</p>
                  <p className="text-[13px] text-[#374747] leading-relaxed">
                    [ Founder bio — background, vision, and inspiration behind MediSYS Pharmacy ]
                  </p>
                </div>
              </div>

              // ── Add more founders below using the same structure ──

            </div>
          </div>
        </div>
        */}

        {/* ── Growing With You — dark CTA card ── */}
        <div className="rounded-2xl bg-[#0a1715] border border-[#1e4a46] overflow-hidden">
          <div className="h-[3px] bg-gradient-to-r from-[#1e4a46] via-[#5fbdb3] to-[#ff601e]" />
          <div className="p-6 sm:p-8 flex flex-col sm:flex-row items-start sm:items-center gap-6">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-2">
                <span className="w-4 h-[2px] bg-[#ff601e] rounded-full" />
                <span className="text-[10px] font-bold uppercase tracking-widest text-[#ff601e]">
                  Growing with You
                </span>
              </div>
              <h2
                className="text-[20px] sm:text-[24px] font-black text-white mb-3"
                style={{ fontFamily: "'Nunito',sans-serif" }}
              >
                Reaching More Communities
              </h2>
              <p className="text-[14px] text-[#8faba9] leading-relaxed max-w-[520px]">
                With multiple branches across Hyderabad and a rapidly expanding
                presence, MediSYS Pharmacy is committed to reaching more
                communities, enhancing healthcare access, and building a
                healthier future for all.
              </p>
            </div>
            <Link to="/products" className="flex-shrink-0">
              <button className="flex items-center gap-2 bg-[#1e4a46] hover:bg-[#ff601e] text-white font-bold text-[13px] px-6 h-11 rounded-xl transition-all duration-200 border-none shadow-[0_4px_18px_rgba(22,44,42,0.3)] hover:shadow-[0_6px_24px_rgba(255,96,30,0.4)]">
                Shop Now
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </button>
            </Link>
          </div>
        </div>

        {/* ── Closing tagline ── */}
        <div className="text-center py-2">
          <p className="text-[13px] sm:text-[14px] text-[#8faba9] font-medium italic">
            "MediSYS Pharmacy – Where Healthcare Meets Convenience, Innovation,
            and Trust."
          </p>
        </div>
      </div>

      <style>{`@keyframes fadeInUp { from { opacity:0; transform:translateY(16px); } to { opacity:1; transform:translateY(0); } }`}</style>
    </div>
  );
};

export default AboutUs;
